/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import './styles/video.css';
import VanillaCropper from './cropper';

export class Cropper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.cropper = null;
    this.videoId = _.uniqueId('video-cropper-video-');
  }

  componentDidMount() {
    this.cropper = new VanillaCropper(`#${this.videoId}`, this.props.options);
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps.options.targetSetting, this.props.options.targetSetting) ||
      !_.isEqual(prevProps.options.handlerMode, this.props.options.handlerMode) ||
      !_.isEqual(prevProps.options.aspectRatio, this.props.options.aspectRatio) ||
      !_.isEqual(prevProps.options.minSize, this.props.options.minSize) ||
      !_.isEqual(prevProps.options.maxSize, this.props.options.maxSize) ||
      !_.isEqual(prevProps.options.startSize, this.props.options.startSize)
    ) {
      this.cropper.destroy();
      this.cropper = new VanillaCropper(`#${this.videoId}`, this.props.options);
    }
  }

  componentWillUnmount() {
    /* istanbul ignore else */
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  reset() {
    /* istanbul ignore else */
    if (this.cropper) {
      this.cropper.reset();
    }
  }

  moveTo(x, y) {
    /* istanbul ignore else */
    if (this.cropper) {
      this.cropper.moveTo(x, y);
    }
  }

  resizeTo(width, height, origin = [0.5, 0.5]) {
    /* istanbul ignore else */
    if (this.cropper) {
      this.cropper.resizeTo(width, height, origin);
    }
  }

  scaleBy(factor, origin = [0.5, 0.5]) {
    /* istanbul ignore else */
    if (this.cropper) {
      this.cropper.scaleBy(factor, origin);
    }
  }

  render() {
    return (
      <div className="video-cropper-container">
        <div id={this.videoId}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Cropper.propTypes = {
  options: PropTypes.shape({
    aspectRatio: PropTypes.number,
    targetSetting: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }).isRequired,
    maxSize: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      unit: PropTypes.string,
    }),
    minSize: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      unit: PropTypes.string,
    }),
    startSize: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      unit: PropTypes.string,
    }),
    onCropStart: PropTypes.func,
    onCropMove: PropTypes.func,
    onCropEnd: PropTypes.func,
    onInitialize: PropTypes.func,
    handlerMode: PropTypes.oneOf(['quadra', 'octo']),
  }).isRequired,
  children: PropTypes.element.isRequired,
};
